import * as React from 'react';

type ArrowUpProps = {
  size?: number | string;
  title?: string;
  className?: string;
  style?: React.CSSProperties;
};

export function ArrowUpIcon({
  size = 14,
  title = 'Arrow up',
  className,
  style,
}: ArrowUpProps) {
  const s = typeof size === 'number' ? `${size}px` : size;

  return (
    <span
      role='img'
      aria-label={title}
      title={title}
      className={className}
      style={{
        display: 'inline-block',
        width: s,
        height: s,
        overflow: 'hidden',
        lineHeight: 0,
        ...style,
      }}
    >
      <svg
        width='100%'
        height='100%'
        viewBox='0 0 14 8'
        preserveAspectRatio='xMidYMid meet'
        xmlns='http://www.w3.org/2000/svg'
        style={{ display: 'block' }}
      >
        <g transform='rotate(180 7 4)'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L7 5.58579L12.2929 0.292893C12.6834 -0.0976311 13.3166 -0.0976311 13.7071 0.292893C14.0976 0.683417 14.0976 1.31658 13.7071 1.70711L7.70711 7.70711C7.31658 8.09763 6.68342 8.09763 6.29289 7.70711L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z'
            fill='currentColor'
          />
        </g>
      </svg>
    </span>
  );
}
